import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Register the ScrollTrigger plugin with GSAP
gsap.registerPlugin(ScrollTrigger);

// Define RefType for TypeScript
type RefType = {
  current: HTMLElement | null;
};

/**
 * Animates the text content with a fade-in and slide-up effect
 */
export const animateText = (textRef: RefType, sectionRef: RefType): void => {
  if (!textRef.current || !sectionRef.current) return;

  gsap.fromTo(
    textRef.current,
    { opacity: 0, y: 30 },
    {
      opacity: 1,
      y: 0,
      duration: 0.8,
      ease: "power3.out",
      scrollTrigger: {
        id: "aboutDispensary-text",
        trigger: sectionRef.current,
        start: "top 70%",
        once: true,
      },
    }
  );
};

/**
 * Animates the image container with a fade-in and scale effect
 */
export const animateImage = (imageRef: RefType, sectionRef: RefType): void => {
  if (!imageRef.current || !sectionRef.current) return;

  gsap.fromTo(
    imageRef.current,
    { opacity: 0, scale: 0.95 },
    {
      opacity: 1,
      scale: 1,
      duration: 0.8,
      delay: 0.3,
      ease: "power3.out",
      scrollTrigger: {
        id: "aboutDispensary-image",
        trigger: sectionRef.current,
        start: "top 70%",
        once: true,
      },
    }
  );
};

/**
 * Fades in images with GSAP animation following the standardized pattern
 */
export const fadeInImage = (img: HTMLImageElement, index: number): void => {
  if (!img) return;

  gsap.to(img, {
    opacity: 1,
    duration: 0.5,
    delay: 0.1 * Math.min(index, 3), // Cap delay at 4 items
    ease: "power2.out",
  });
};

/**
 * Cleans up only AboutDispensary ScrollTrigger instances
 */
export const cleanupScrollTriggers = (): void => {
  ScrollTrigger.getAll()
    .filter((trigger) => trigger.vars.id?.startsWith("aboutDispensary"))
    .forEach((trigger) => trigger.kill());
};
